module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_27.3a6679d1.jpg";